<template>
	<Popup
		v-model="selfDisplay"
		title="新增检测设备"
		confirmBtnText="新增"
		@confirmClick="handleAddClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>所属机构</span>
				<el-select v-model="oid" class="b_inp" filterable placeholder="请选择" :clearable="true">
					<el-option
						v-for="v in allOrganization"
						:key="v.id"
						:label="v.name"
						:value="v.id">
					</el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="oidTip"><i class="b_icon"></i>请选择所属机构</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>设备类型</span>
				<el-select v-model="deviceType" class="b_inp" placeholder="请选择" :clearable="true">
					<el-option
						v-for="v in allDeviceType"
						:key="v.id"
						:label="v.name"
						:value="v.id">
					</el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="deviceTypeTip"><i class="b_icon"></i>请选择设备类型</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>机构内编号</span>
				<el-input v-model="onumber" placeholder="机构内编号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="onumberTip"><i class="b_icon"></i>机构内编号不合法</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>设备ID</span>
				<el-input v-model="deviceId" placeholder="设备ID"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="deviceIdTip"><i class="b_icon"></i>请输入设备ID</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>屏幕分辨率</span>
				<el-input v-model="screenResolution" placeholder="屏幕分辨率"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="screenResolutionTip"><i class="b_icon"></i>请输入屏幕分辨率</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>设备型号</span>
				<el-input v-model="deviceModel" placeholder="设备型号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="deviceModelTip"><i class="b_icon"></i>请输入设备型号</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>设备尺寸</span>
				<el-input v-model="deviceSize" placeholder="设备尺寸"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="deviceSizeTip"><i class="b_icon"></i>设备尺寸不合法</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>gamma</span>
				<el-input v-model="gamma" placeholder="gamma"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="gammaTip"><i class="b_icon"></i>gamma不合法</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>软件版本号</span>
				<el-input v-model="softwareVersion" placeholder="软件版本号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="softwareVersionTip"><i class="b_icon"></i>请输入软件版本号</template></div>
		</div>
	</Popup>
</template>

<script>
	import { mapState } from 'vuex';
	import Api from '../../../../../../api/index.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				oid: '',
				deviceType: '',
				onumber: '',
				deviceId: '',
				screenResolution: '',
				deviceModel: '',
				deviceSize: '',
				gamma: '',
				softwareVersion: '',
				oidTip: false,
				deviceTypeTip: false,
				onumberTip: false,
				deviceIdTip: false,
				screenResolutionTip: false,
				deviceModelTip: false,
				deviceSizeTip: false,
				gammaTip: false,
				softwareVersionTip: false
			}
		},
		computed: {
			...mapState([
				'allOrganization',
				'allDeviceType'
			])
		},
		methods: {
			// 点击新增
			handleAddClick() {
				if (!this.oid) {
					this.oidTip = true;
					return false;
				} else {
					this.oidTip = false;
				}
				if (!this.deviceType) {
					this.deviceTypeTip = true;
					return false;
				} else {
					this.deviceTypeTip = false;
				}
				if (!this.floatReg.test(this.onumber)) {
					this.onumberTip = true;
					return false;
				} else {
					this.onumberTip = false;
				}
				if (!this.deviceId.trim()) {
					this.deviceIdTip = true;
					return false;
				} else {
					this.deviceIdTip = false;
				}
				if (!this.screenResolution.trim()) {
					this.screenResolutionTip = true;
					return false;
				} else {
					this.screenResolutionTip = false;
				}
				if (!this.deviceModel.trim()) {
					this.deviceModelTip = true;
					return false;
				} else {
					this.deviceModelTip = false;
				}
				if (!this.floatReg.test(this.deviceSize)) {
					this.deviceSizeTip = true;
					return false;
				} else {
					this.deviceSizeTip = false;
				}
				if (!this.floatReg.test(this.gamma)) {
					this.gammaTip = true;
					return false;
				} else {
					this.gammaTip = false;
				}
				if (!this.softwareVersion.trim()) {
					this.softwareVersionTip = true;
					return false;
				} else {
					this.softwareVersionTip = false;
				}
				this.add();
			},
			// 新增
			add() {
				const that = this;
				that.loading = true;
				let requestData = {
					enterpriseId: that.oid,
					deviceNo: that.onumber,
					enterpriseType: that.deviceType,
					resolvingPower: that.screenResolution,
					deviceType: that.deviceModel,
					deviceSize: that.deviceSize,
					uuId: that.deviceId,
					gamma: that.gamma,
					softVersion: that.softwareVersion
				};
				Api.addVisualDetectionDevice(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.loading = false;
					this.oid = '';
					this.deviceType = '';
					this.onumber = '';
					this.deviceId = '';
					this.screenResolution = '';
					this.deviceModel = '';
					this.deviceSize = '';
					this.gamma = '';
					this.softwareVersion = '';
					this.oidTip = false;
					this.deviceTypeTip = false;
					this.onumberTip = false;
					this.deviceIdTip = false;
					this.screenResolutionTip = false;
					this.deviceModelTip = false;
					this.deviceSizeTip = false;
					this.gammaTip = false;
					this.softwareVersionTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
